import React from 'react';
import SideNav from '../../Common/SideNav/SideNav';
import { hasActiveChild, isRouteActive, isNavItem, navBubble } from '../index';
import { NavSection } from '../types';

interface SideNavSectionProps {
  section: NavSection;
  sectionIndex: number;
  pathname: string;
  isOpen: boolean;
  toggleSection: (key: string) => void;
  trackAction: (data: { elementId: string; type: 'click' }) => void;
}

/**
 * Renders a section with only items (nesting levels 0 -> 1)
 */
export const SideNavSection = ({
  section,
  sectionIndex,
  pathname,
  isOpen,
  toggleSection,
  trackAction,
}: SideNavSectionProps) => {
  return (
    <>
      <SideNav.GroupToggle
        title={section.title!}
        url={section.route?.[0]}
        isActive={isRouteActive(pathname, section.route)}
        hasActiveChild={hasActiveChild(pathname, section)}
        withReactRouter={!!(section.route && !section.route[0]?.startsWith('http'))}
        showMenuItems={isOpen}
        onClick={() => toggleSection(String(sectionIndex))}
      />
      <SideNav.Group>
        {section.children.filter(isNavItem).map((item, itemIndex) => {
          return (
            <SideNav.Item
              key={`${sectionIndex}-${itemIndex}`}
              title={item.label}
              url={item.route[0]}
              isActive={isRouteActive(pathname, item.route)}
              isVisible={isOpen}
              openInNewTab={item.target === '_blank'}
              withReactRouter={!item.target}
              bubble={navBubble(item.bubble)}
              nestingLevel={1}
              onClick={() => trackAction({ elementId: `sidebar-link-${item.id}`, type: 'click' })}
            />
          );
        })}
      </SideNav.Group>
    </>
  );
};
